import { Client } from "./_clientService";

export async function getBettingMarkets() {
  // const response = await new Client({
  //   path: `/misc/bettingMarkets`,
  // }).get();
  const response = {
    data: {
      markets: [
        "BTTS",
        "CORRECT_SCORE",
        "FINAL_RESULT",
        "FIRST_LAST_ANY_GOAL_SCORE",
        "HANDICAPS",
        "RESULT_BTTS",
        "UNDER_OVER",
        "MATCH_RESULT_UNDER_OVER",
        "BTTS_UNDER_OVER",
      ],
    },
  };

  return response;
}

export async function getDefaultMarginInfo() {
  const resp = await new Client({ path: "/operator/base-market/info" }).post();
  return resp;
}

export async function updateDefaultMargin(payload: any) {
  const resp = await new Client({
    path: "/operator/base-market/update",
    payload,
  }).patch();
  return resp;
}
